import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/agent/atividades_faq_head_1.png'
import _imports_1 from '@/assets/agent/atividades_faq_icon_2.png'
import _imports_2 from '@/assets/agent/atividades_faq_icon_3.png'
import _imports_3 from '@/assets/agent/atividades_faq_icon_4.png'


const _hoisted_1 = { class: "rule_card" }
const _hoisted_2 = { class: "rule_title" }
const _hoisted_3 = { class: "rule_details" }
const _hoisted_4 = { class: "text1" }
const _hoisted_5 = { class: "text2" }
const _hoisted_6 = { class: "tip_text1" }
const _hoisted_7 = { class: "tip_text2" }
const _hoisted_8 = { class: "tip_text3" }
const _hoisted_9 = { class: "tip_text4" }
const _hoisted_10 = { class: "tip_text5" }
const _hoisted_11 = {
  class: "tip_frame2",
  style: {"margin-bottom":"15px"}
}
const _hoisted_12 = { class: "rules_text" }
const _hoisted_13 = { class: "text_title" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "text_title" }
const _hoisted_16 = ["innerHTML"]

import { ref } from 'vue';
import BetCard from './betCard.vue';

const total_performance = 2500;
const sub_performance = 1980

export default /*@__PURE__*/_defineComponent({
  __name: 'ruleCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('rulecard.communicationRules')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "6",
            class: "faq_head_img"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "18",
            class: "faq_head"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('rulecard.faqHead1')), 1),
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "110", -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('rulecard.faqHead2')), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, { style: {"padding":"10px 0"} }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "20",
            class: "perfo_title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('rulecard.perfoTitle1')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "4",
            class: "perfo_value"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(total_performance))
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "20",
            class: "perfo_title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('rulecard.perfoTitle2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "4",
            class: "perfo_value"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(sub_performance))
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "20",
            class: "perfo_title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('rulecard.perfoTitle3')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "4",
            class: "perfo_value"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(total_performance - sub_performance), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, { style: {"margin":"15% 0"} }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "8",
            class: "arrowContent"
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText1')) + " ", 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "1320", -1))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText2')) + " ", 1),
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "520", -1))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "8",
            class: "arrowContent"
          }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("img", {
                src: _imports_2,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText3')) + " A:", 1),
                _cache[5] || (_cache[5] = _createElementVNode("span", null, "440", -1))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "8",
            class: "arrowContent"
          }, {
            default: _withCtx(() => [
              _cache[9] || (_cache[9] = _createElementVNode("img", {
                src: _imports_3,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText4')) + " ", 1),
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "0", -1))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText5')) + " ", 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "220", -1))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "8",
            class: "bet_column"
          }, {
            default: _withCtx(() => [
              _createVNode(BetCard, {
                content: _ctx.$t('rulecard.subAgentWins'),
                infoValue: "70",
                bottomText: "120K",
                cardImage: require('@/assets/agent/atividades_faq_head_2.png'),
                topBackground: "rgba(240, 168, 83, 0.50)",
                downBackground: "#F0A853"
              }, null, 8, ["content", "cardImage"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "8",
            class: "bet_column"
          }, {
            default: _withCtx(() => [
              _createVNode(BetCard, {
                content: _ctx.$t('rulecard.noProfit'),
                bottomText: "120K",
                cardImage: require('@/assets/agent/atividades_faq_head_3.png'),
                topBackground: "rgba(240, 168, 83, 0.50)",
                downBackground: "#F0A853"
              }, null, 8, ["content", "cardImage"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "8",
            class: "bet_column"
          }, {
            default: _withCtx(() => [
              _createVNode(BetCard, {
                content: _ctx.$t('rulecard.wins'),
                infoValue: "70",
                bottomText: "120K",
                cardImage: require('@/assets/agent/atividades_faq_head_4.png'),
                topBackground: "rgba(240, 168, 83, 0.50)",
                downBackground: "#F0A853"
              }, null, 8, ["content", "cardImage"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_van_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "8",
              class: "tip_text6"
            }, {
              default: _withCtx(() => [
                _cache[12] || (_cache[12] = _createElementVNode("img", {
                  src: _imports_2,
                  alt: ""
                }, null, -1)),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText3')) + " A: ", 1),
                  _cache[10] || (_cache[10] = _createElementVNode("span", null, "400", -1))
                ]),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText3')) + " B1: ", 1),
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "700", -1))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "8",
              class: "tip_text6"
            }, {
              default: _withCtx(() => [
                _cache[15] || (_cache[15] = _createElementVNode("img", {
                  style: {"margin-left":"-70%"},
                  src: _imports_3,
                  alt: ""
                }, null, -1)),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText3')) + " A: ", 1),
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "120", -1))
                ]),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText3')) + " B2: ", 1),
                  _cache[14] || (_cache[14] = _createElementVNode("span", null, "210", -1))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "8",
              class: "tip_text6"
            }, {
              default: _withCtx(() => [
                _cache[18] || (_cache[18] = _createElementVNode("img", {
                  src: _imports_2,
                  alt: ""
                }, null, -1)),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText3')) + " A: ", 1),
                  _cache[16] || (_cache[16] = _createElementVNode("span", null, "0", -1))
                ]),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('rulecard.tipText3')) + " B3: ", 1),
                  _cache[17] || (_cache[17] = _createElementVNode("span", null, "33000", -1))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "8",
            class: "bet_column"
          }, {
            default: _withCtx(() => [
              _createVNode(BetCard, {
                content: _ctx.$t('rulecard.subAgentWins'),
                infoValue: "70",
                bottomText: "120K",
                cardImage: require('@/assets/agent/atividades_faq_head_5.png'),
                topBackground: "#DD7A33",
                downBackground: "#FF780D"
              }, null, 8, ["content", "cardImage"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "8",
            class: "bet_column"
          }, {
            default: _withCtx(() => [
              _createVNode(BetCard, {
                content: _ctx.$t('rulecard.noProfit'),
                bottomText: "120K",
                cardImage: require('@/assets/agent/atividades_faq_head_6.png'),
                topBackground: "#DD7A33",
                downBackground: "#FF780D"
              }, null, 8, ["content", "cardImage"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "8",
            class: "bet_column"
          }, {
            default: _withCtx(() => [
              _createVNode(BetCard, {
                content: _ctx.$t('rulecard.wins'),
                infoValue: "70",
                bottomText: "120K",
                cardImage: require('@/assets/agent/atividades_faq_head_7.png'),
                topBackground: "#DD7A33",
                downBackground: "#FF780D"
              }, null, 8, ["content", "cardImage"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('rulecard.exampleTitle')), 1),
        _createElementVNode("div", {
          class: "text_content",
          innerHTML: _ctx.$t('rulecard.exampleContent')
        }, null, 8, _hoisted_14),
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('rulecard.exampleTitle2')), 1),
        _createElementVNode("div", {
          class: "text_content",
          innerHTML: _ctx.$t('rulecard.exampleContent2')
        }, null, 8, _hoisted_16)
      ])
    ])
  ]))
}
}

})